<template>
  <form @submit.prevent="save" class="main-modal main-modal_w500 main-form">
    <div class="main-modal__title">
      <p>Problem:</p>
    </div>

    <div class="main-form__box">
      <label class="main-form__label" for=""> Titel:</label>
      <input
        type="text"
        v-model="problem.name"
        placeholder="Titel"
        class="main-form__input"
      />
    </div>

    <div class="main-form__box">
      <label class="main-form__label" for="">Leistungen:</label>
      <Select2
        class="select2-container_w100"
        v-model="problem.service_id"
        :settings="selectSettings.services"
        :options="services"
      />
    </div>

    <div class="main-form__buttons main-form__buttons_center">
      <span @click="$emit('close')" class="main-button main-button_cancel">{{
        $t("global.cancel")
      }}</span>
      <button
        type="submit"
        :disabled="!isChecked"
        class="main-button main-button_success"
      >
        {{ $t("global.save") }}
      </button>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            selectSettings: 'orders/selectSettingsGetters',
            services: 'servicesGetters',
            problem: 'problems/problem',
        }),
        isChecked() {
            if (this.problem.name === '') return false
            return !(this.problem.service_id === '' || this.problem.service_id === null)
        },
    },
    methods: {
        ...mapActions({
            fetch: 'problems/fetch',
            add: 'problems/add',
        }),
        ...mapMutations({
            setState: 'problems/setState',
        }),
        async save() {
            this.$emit('done')
            // const isOkey = await this.add();
            // if (!isOkey) return;
            // await this.fetch();
            // this.setState({
            //   key: "isShowModal",
            //   data: false,
            // });
        },
    },
}
</script>
